import I18n from 'I18n';
import Features from 'self-service-api/constants/Features';

// @ts-expect-error dependency missing types
import BUYER_INTENT_IMG from 'bender-url!pricing-pages-lib/images/keyFeatures/Buyer_Intent.png';
// @ts-expect-error dependency missing types
import DATA_ENRICHMENT_IMG from 'bender-url!pricing-pages-lib/images/keyFeatures/Data_Enrichment.png';
// @ts-expect-error dependency missing types
import FORM_SHORTENING_IMG from 'bender-url!pricing-pages-lib/images/keyFeatures/Form_Shortening.png';
// @ts-expect-error dependency missing types
import SMART_PROPERTIES_IMG from 'bender-url!pricing-pages-lib/images/keyFeatures/Smart_Properties.png';
// @ts-expect-error dependency missing types
import INSTANT_247_SUPPORT from 'bender-url!pricing-pages-lib/images/keyFeatures/Instant_247_Support.png';
// @ts-expect-error dependency missing types
import TRUSTED_RESPONSES from 'bender-url!pricing-pages-lib/images/keyFeatures/Trusted_Responses.png';
// @ts-expect-error dependency missing types
import SEAMLESS_SUPPORT from 'bender-url!pricing-pages-lib/images/keyFeatures/Seamless_Support.png';
// @ts-expect-error dependency missing types
import HUBSPOT_CREDITS_HERO from 'bender-url!pricing-pages-lib/images/hubspot-credits/hero.png';
// @ts-expect-error dependency missing types
import BREEZE_ACTIONS_WORKFLOWS from 'bender-url!pricing-pages-lib/images/keyFeatures/breezeActionsWorkflows.png';
// @ts-expect-error dependency missing types
import BUYER_INTENT_INBOUND from 'bender-url!pricing-pages-lib/images/keyFeatures/buyerIntentInbound.png';
// @ts-expect-error dependency missing types
import CUSTOMER_AGENT from 'bender-url!pricing-pages-lib/images/keyFeatures/customerAgent.png';
// @ts-expect-error dependency missing types
import CUSTOMER_AGENT_CALLOUT from 'bender-url!pricing-pages-lib/images/keyFeatures/customerAgent_callout.png';
// @ts-expect-error dependency missing types
import DATA_AGENT from 'bender-url!pricing-pages-lib/images/keyFeatures/dataAgent.png';
// @ts-expect-error dependency missing types
import DATA_AGENT_CALLOUT from 'bender-url!pricing-pages-lib/images/keyFeatures/dataAgent_callout.png';
// @ts-expect-error dependency missing types
import DATA_STUDIO from 'bender-url!pricing-pages-lib/images/keyFeatures/dataStudio.png';
// @ts-expect-error dependency missing types
import DATA_STUDIO_CALLOUT from 'bender-url!pricing-pages-lib/images/keyFeatures/dataStudio_callout.png';
// @ts-expect-error dependency missing types
import PROSPECTING_AGENT from 'bender-url!pricing-pages-lib/images/keyFeatures/prospectingAgent.png';
// @ts-expect-error dependency missing types
import PROSPECTING_AGENT_CALLOUT from 'bender-url!pricing-pages-lib/images/keyFeatures/prospectingAgent_callout.png';
import { DE, ES, FR, JA, PT } from 'self-service-api/constants/Languages';
import { CREDITS_RELATED_FEATURES } from '../../utils/getHubSpotCreditsKeyFeatures';
const SUPPORTED_LANGS = ['en', 'es', 'fr', 'de', 'pt', 'ja', 'nl'];
const CMS_BASE_URL = 'https://f.hubspotusercontent00.net/hubfs/53';
const getImageUrl = extension => CMS_BASE_URL + extension;
const getDataEnrichmentImages = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
      return getImageUrl(`/International%20Web/data-enrichment/Company-record-Re-enrichmen-${langToUse.toUpperCase()}.png`);
    case PT:
      return getImageUrl(`/International%20Web/data-enrichment/Company-record-Re-enrichmen-${langToUse.toUpperCase()}.jpg`);
    default:
      return DATA_ENRICHMENT_IMG;
  }
};
const getBuyerIntentImages = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      return getImageUrl(`/International%20Web/buyer-intent/buyer-intent-filters-${langToUse.toLowerCase()}.png`);
    default:
      return BUYER_INTENT_IMG;
  }
};
const getFormShorteningImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      return getImageUrl(`/International%20Web/form-shortening/form-shortening-submissions-other-values-${langToUse.toLowerCase()}.png`);
    default:
      return FORM_SHORTENING_IMG;
  }
};
const getSmartPropertiesImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      // TODO: Add localized image urls
      return SMART_PROPERTIES_IMG;
    default:
      return SMART_PROPERTIES_IMG;
  }
};
const getInstant247SupportImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
      return getImageUrl(`/International%20Web/agents/agents-nobackround/Customer%20Agent%20%232_JP-without%20background.png`);
    case ES:
    case FR:
    case DE:
    case PT:
      return getImageUrl(`/International%20Web/agents/agents-nobackround/Customer%20Agent%20%232_${langToUse.toUpperCase()}-without%20background.png`);
    default:
      return INSTANT_247_SUPPORT;
  }
};
const getTrustedResponsesImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
      return getImageUrl(`/International%20Web/agents/agents-nobackround/Prospecting%20Agent%20%231_JP-without%20background.png`);
    case ES:
    case FR:
    case DE:
    case PT:
      return getImageUrl(`/International%20Web/agents/agents-nobackround/Prospecting%20Agent%20%231_${langToUse.toUpperCase()}-without%20background.png`);
    default:
      return TRUSTED_RESPONSES;
  }
};
const getSeamlessSupportImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
      return getImageUrl(`/International%20Web/agents/agents-nobackround/Customer%20Agent%20%233_JP-without%20background.png`);
    case ES:
    case FR:
    case DE:
    case PT:
      return getImageUrl(`/International%20Web/agents/agents-nobackround/Customer%20Agent%20%233_${langToUse.toUpperCase()}-without%20background.png`);
    default:
      return SEAMLESS_SUPPORT;
  }
};
export const getHubSpotCreditsHeroImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      // TODO: Add localized image urls
      return HUBSPOT_CREDITS_HERO;
    default:
      return HUBSPOT_CREDITS_HERO;
  }
};
const getDataAgentFeatureImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      // TODO: Add localized image urls
      return DATA_AGENT;
    default:
      return DATA_AGENT;
  }
};
export const getDataAgentCalloutImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      // TODO: Add localized image urls
      return DATA_AGENT_CALLOUT;
    default:
      return DATA_AGENT_CALLOUT;
  }
};
const getCustomerAgentFeatureImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      // TODO: Add localized image urls
      return CUSTOMER_AGENT;
    default:
      return CUSTOMER_AGENT;
  }
};
export const getCustomerAgentCalloutImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      // TODO: Add localized image urls
      return CUSTOMER_AGENT_CALLOUT;
    default:
      return CUSTOMER_AGENT_CALLOUT;
  }
};
const getBreezeActionsWorkflowsFeatureImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      // TODO: Add localized image urls
      return BREEZE_ACTIONS_WORKFLOWS;
    default:
      return BREEZE_ACTIONS_WORKFLOWS;
  }
};
const getProspectingAgentFeatureImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      // TODO: Add localized image urls
      return PROSPECTING_AGENT;
    default:
      return PROSPECTING_AGENT;
  }
};
export const getProspectingAgentCalloutImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      // TODO: Add localized image urls
      return PROSPECTING_AGENT_CALLOUT;
    default:
      return PROSPECTING_AGENT_CALLOUT;
  }
};
const getBuyerIntentInboundFeatureImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      // TODO: Add localized image urls
      return BUYER_INTENT_INBOUND;
    default:
      return BUYER_INTENT_INBOUND;
  }
};
const getDataStudioFeatureImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      // TODO: Add localized image urls
      return DATA_STUDIO;
    default:
      return DATA_STUDIO;
  }
};
export const getDataStudioCalloutImage = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';
  switch (langToUse) {
    case JA:
    case ES:
    case FR:
    case DE:
    case PT:
      // TODO: Add localized image urls
      return DATA_STUDIO_CALLOUT;
    default:
      return DATA_STUDIO_CALLOUT;
  }
};
export const getLocalizedImages = name => {
  switch (name) {
    case Features.DATA_ENRICHMENT:
      return getDataEnrichmentImages();
    case Features.BUYER_INTENT:
      return getBuyerIntentImages();
    case Features.FORM_SHORTENING:
      return getFormShorteningImage();
    case 'smartProperties':
      return getSmartPropertiesImage();
    case 'instant247Support':
      return getInstant247SupportImage();
    case 'trustedResponses':
      return getTrustedResponsesImage();
    case 'seamlessSupport':
      return getSeamlessSupportImage();
    case CREDITS_RELATED_FEATURES.breezeActionsWorkflows:
      return getBreezeActionsWorkflowsFeatureImage();
    case CREDITS_RELATED_FEATURES.buyerIntent:
      return getBuyerIntentInboundFeatureImage();
    case CREDITS_RELATED_FEATURES.customerAgent:
      return getCustomerAgentFeatureImage();
    case CREDITS_RELATED_FEATURES.dataAgent:
      return getDataAgentFeatureImage();
    case CREDITS_RELATED_FEATURES.dataStudio:
      return getDataStudioFeatureImage();
    case CREDITS_RELATED_FEATURES.prospectingAgent:
      return getProspectingAgentFeatureImage();
    default:
      return [];
  }
};